import { http } from '@api/base-http';
import { ICreateApiKeyPayload, IUpdateApiKeyPayload } from '../types/apiKeys';

export interface IApiKeysParams {
  after?: string;
  field?: string;
  order?: string;
  filter?: string;
  limit?: number;
  page_number?: number | null;
}

export const fetchApiKeysApi = <T>(params?: IApiKeysParams) => {
  const paramsMap: IApiKeysParams = Object.entries(params || {}).reduce((acc, [field, value]) => {
    if (value)
      acc[field as keyof IApiKeysParams] =
        field === 'page_number' && params?.after ? undefined : value;
    return acc;
  }, {} as IApiKeysParams);

  return http.get<T>(`/api/v1/token`, { params: paramsMap });
};

export const createApiKeyApi = <T>(payload: ICreateApiKeyPayload) => {
  return http.post<T>('/api/v1/token', payload);
};

export const updateApiKeyApi = <T>(apiKeyId: string, payload: IUpdateApiKeyPayload) => {
  return http.patch<T>(`/api/v1/token/${apiKeyId}`, payload);
};

export const deleteApiKeyApi = <T>(apiKeyId: string) => {
  return http.delete<T>(`/api/v1/token/${apiKeyId}`);
};
